import React from "react";
import { getPaymentStatusMeta } from "../utils/paymentStatus";

const initialsOf = (name) =>
  (name || "")
    .split(/\s+/)
    .filter((w) => w && !/^(SRL|SA|SC)$/i.test(w))
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

const ClientRow = ({ client, onRowClick, canDelete, onDeleteRequest, formatCurrency }) => {
  const isCompany = client.buyer_type === "LEGAL";
  const displayName = isCompany
    ? client.legal_company_name || client.name
    : `${client.name} ${client.surname || ""}`.trim();
  const idText = isCompany ? client.legal_fiscal_code : client.social_security_number;
  const sub = client.linked_contact_name ? `Linked · ${client.linked_contact_name}` : idText;
  const statusMeta = getPaymentStatusMeta(client.payment_status, client.next_payment, formatCurrency);
  const value = client.total_value || 0;
  const paid = client.total_paid || 0;
  const outstanding = value - paid;

  return (
    <tr onClick={() => onRowClick(client.id)} className="hover-row" style={{ cursor: "pointer" }}>
      <td style={{ minWidth: 0 }}>
        <div className="d-flex align-items-center gap-2">
          <span
            style={{
              flex: "none",
              width: 32,
              height: 32,
              borderRadius: 9,
              background: isCompany ? "#e8f1fb" : "#1b1b21",
              color: isCompany ? "#1c5b8f" : "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 11,
              fontWeight: 700,
            }}
          >
            {initialsOf(displayName) || "?"}
          </span>
          <div style={{ minWidth: 0 }}>
            <div className="fw-semibold text-truncate">{displayName || "—"}</div>
            <div className="text-muted text-truncate" style={{ fontSize: 11.5 }}>{sub || "—"}</div>
          </div>
        </div>
      </td>
      <td style={{ minWidth: 0 }}>
        <div className="text-truncate" style={{ fontSize: 13 }}>
          {client.personal_email || client.business_email || "—"}
        </div>
        <div className="text-muted" style={{ fontSize: 11.5 }}>
          {client.mobile_phone_number || "— no phone"}
        </div>
      </td>
      <td>
        <div className="fw-semibold" style={{ fontVariantNumeric: "tabular-nums" }}>
          {client.contracts_count === 0 ? "None" : client.contracts_count}
        </div>
        <div className="text-muted text-truncate" style={{ fontSize: 11.5 }}>
          {client.contracts_count === 0 ? "no units" : client.phase_name || "—"}
        </div>
      </td>
      <td style={{ minWidth: 0 }}>
        <div className="d-flex align-items-center gap-2">
          <span style={{ width: 7, height: 7, borderRadius: "50%", background: statusMeta.dotColor, flex: "none" }} />
          <span className={statusMeta.textClass} style={{ fontVariantNumeric: "tabular-nums" }}>{statusMeta.label}</span>
        </div>
        {statusMeta.amountText && (
          <div className="text-muted" style={{ fontSize: 11.5 }}>{statusMeta.amountText}</div>
        )}
      </td>
      <td className="text-end">
        <div className="fw-semibold" style={{ fontVariantNumeric: "tabular-nums" }}>
          {value ? formatCurrency(value, "EUR") : "—"}
        </div>
        {value > 0 && (
          <div className="text-muted" style={{ fontSize: 11.5 }}>{formatCurrency(outstanding, "EUR")} open</div>
        )}
      </td>
      <td className="text-end">
        <div className="d-flex align-items-center justify-content-end gap-2">
          {canDelete && (
            <button
              type="button"
              className="btn btn-sm btn-icon btn-ghost-danger"
              onClick={(e) => {
                e.stopPropagation();
                onDeleteRequest(client);
              }}
            >
              <i className="ri-delete-bin-5-fill fs-16"></i>
            </button>
          )}
          <i className="ri-arrow-right-s-line text-muted"></i>
        </div>
      </td>
    </tr>
  );
};

export default ClientRow;
